<template>
    <el-form>
        <element class="invoice-modal-row">
            <el-form-item class="invoice-modal-item">
                <label class="invoice-modal-mandatory">{{ translate('add_modal.crop') }} <span>*</span></label>
                <el-select
                    v-model="data.cultivationId"
                    :placeholder="translate('add_modal.cultivation_placeholder')"
                    disabled
                >
                    <el-option
                        :label="cultivation.nome"
                        :value="cultivation.id"
                        v-for="cultivation in cultivationsFiltered"
                        :key="cultivation.codigo"
                    >
                        {{ cultivation.nome }}
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="invoice-modal-item">
                <label class="invoice-modal-mandatory">{{ translate('add_modal.agricultural_campaign') }} <span>*</span></label>
                <el-select
                    v-model="data.cropId"
                    :placeholder="translate('add_modal.crop_placeholder')"
                    disabled
                >
                    <el-option
                        :label="safra.ano"
                        :value="safra.id"
                        v-for="safra in safrasFiltered"
                        :key="safra.ano"
                    >
                        {{ safra.ano }}
                    </el-option>
                </el-select>
            </el-form-item>
        </element>
        <element class="invoice-modal-row">
            <el-form-item class="invoice-modal-item">
                <label class="invoice-modal-mandatory">{{ translate('add_modal.invoice_date') }} <span>*</span></label>
                <el-date-picker
                    v-model="data.invoiceDate"
                    :placeholder="translate('add_modal.invoice_date_placeholder')"
                    type='date'
                    format='dd/MM/yyyy'
                />
            </el-form-item>
            <el-form-item class="invoice-modal-item">
                <label class="invoice-modal-mandatory">{{ translate('add_modal.romaneo') }} <span>*</span></label>
                <el-input
                    v-model="data.romaneo"
                    :placeholder="translate('add_modal.romaneo_placeholder')"
                />
            </el-form-item>
        </element>
        <element class="invoice-modal-row">
            <el-form-item class="invoice-modal-item">
                <label class="invoice-modal-mandatory">{{ translate('add_modal.producer') }} <span>*</span></label>
                <el-select
                    v-model="data.producerId"
                    :placeholder="translate('add_modal.producer_placeholder')"
                    filterable
                    remote
                    :remote-method="getProducers"
                    :loading="searchingProducers"
                    :no-data-text="(!searchingProducers && producersSearchText && producersSearchText.length < 3) ? translate('add_modal.type_more_than_three_chars') : translate('add_modal.no_data_text')"
                >
                    <el-option
                        v-for="producer in producers"
                        :key="producer.documento"
                        :label="producer.nome"
                        :value="producer.id"
                    >
                        {{ producer.nome }}
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="invoice-modal-item">
                <label class="invoice-modal-mandatory">{{ translate('add_modal.property') }} <span>*</span></label>
                <el-select
                    v-model="data.propertyId"
                    :placeholder="translate('add_modal.property_placeholder')"
                    filterable
                    remote
                    :remote-method='getProperties'
                    :disabled="!data.producerId"
                    :loading='searchingProperties'
                    :no-data-text="(!searchingProperties && propertiesSearchText && propertiesSearchText.length < 3) ? translate('add_modal.type_more_than_three_chars') : translate('add_modal.no_data_text')"
                >
                    <el-option
                        v-for="property in properties"
                        :key="property.id"
                        :label="property.nome"
                        :value="property.id"
                    >
                        {{ property.nome }}
                    </el-option>
                </el-select>
            </el-form-item>
        </element>
        <el-form-item>
            <label class="invoice-modal-mandatory">{{ translate('add_modal.invoice_number') }}</label>
            <el-input
            v-model="data.invoiceNumber"
            :placeholder="translate('add_modal.invoice_number_placeholder')"
            />
        </el-form-item>
        <el-form-item>
            <label class="invoice-modal-mandatory">{{ translate('add_modal.invoice') }}</label>
            <el-upload
                action="#"
                :show-file-list="true"
                :auto-upload="false"
                :limit="1"
                :on-change="handleFileChange"
                :on-remove="handleFileRemove"
                ref="upload"
            >
                <div v-if="selectedFile" class="invoice-modal-upload-button">
                    <el-tooltip :content="translate('add_modal.onlyOneFile')" placement="top">
                        <el-button size="mini" type="primary" :disabled="true">{{ translate('add_modal.upload_file') }}</el-button>
                    </el-tooltip>
                </div>
                <div v-else class="invoice-modal-upload-button">
                    <el-button size="mini" type="primary">{{ translate('add_modal.upload_file') }}</el-button>
                </div>
            </el-upload>
        </el-form-item>
        <element class="invoice-modal-row">
            <el-form-item class="invoice-modal-item">
                <label class="invoice-modal-mandatory">{{ translate('add_modal.volume') }} (t) <span>*</span></label>
                <el-input
                    v-model.number="data.volume"
                    :placeholder="translate('add_modal.volume_placeholder')"
                    type="number"
                    min="0"
                />
            </el-form-item>
            <el-form-item class="invoice-modal-item">
                <label class="invoice-modal-mandatory">{{ translate('add_modal.truck_license_plate') }}</label>
                <el-input
                    v-model="data.truckLicensePlate"
                    :placeholder="translate('add_modal.truck_license_plate_placeholder')"
                    type="text"
                />
            </el-form-item>
        </element>
        <el-form-item class="invoice-modal-item">
            <label class="invoice-modal-mandatory">{{ translate('add_modal.warehouse') }} <span>*</span></label>
            <el-select
                v-model="data.warehouseId"
                :placeholder="translate('add_modal.warehouse_placeholder')"
                filterable
            >
                <el-option
                    :label="warehouse.unidade"
                    :value="warehouse.id"
                    v-for="warehouse in warehouses"
                    :key="warehouse.unidade"
                >
                    {{ warehouse.unidade }}
                </el-option>
                <div class = "not_found_option" slot="empty">
                    <div class = "not_found_message">
                        <span>
                            {{translate('add_modal.no_warehouses_found')}}
                            <a @click="goToWareHouseRegistration">{{translate('add_modal.warehouse_list_option')}}.</a>
                        </span>
                    </div>

                </div>
            </el-select>
        </el-form-item>

        <element class="invoice-modal-row invoice-modal-buttons">
            <el-button type="secondary" @click="close">
                <span>{{ translate('messages.back') }}</span>
            </el-button>
            <el-button type="primary" @click="addNewInvoice" :disabled="!data.invoiceDate || !data.romaneo || !data.cultivationId || !data.producerId || !data.propertyId || !data.volume || !data.warehouseId || !data.cropId || isRequesting">
                <span>{{ translate('messages.save') }}</span>
            </el-button>
        </element>
    </el-form>
</template>

<script>
import formatters from '@/utils/formatters';
import RepresentanteService from '@/services/RepresentanteService';
import ArmazemModuleService from '@/services/ArmazemModuleService';
import NotaFiscalService from '@/services/NotaFiscalService';
import TerritorioService from '@/services/TerritorioService';
import UtilsService from '@/services/UtilsService';
import { mapActions, mapGetters } from 'vuex';
import { sortBy } from 'lodash';
import { WarehouseListActionsEnum } from '@/modules/warehouse/constants/WarehouseListActionsEnum';

export default {
    name: 'AddInvoiceModalPY',
    props: {
    },
    data() {
        return {
            data: {
                cultivationId: null,
                producerId: null,
                propertyId: null,
                invoiceNumber: null,
                volume: null,
                invoiceDate: null,
                warehouseId: null,
                cropId: null,
                romaneo: null,
                truckLicensePlate: null
            },
            safras: [],
            producers: [],
            properties: [],
            warehouses: [],
            searchingProducers: false,
            searchingProperties: false,
            selectedFile: null,
            isRequesting: false,
            producersSearchText: null,
            propertiesSearchText: null
        };
    },
    async mounted() {
        await this.fetchWarehouses();
        await this.fetchSafras();
        await this.fetchCultivations();
        this.setDefaultCultivationAndCrop();
    },
    computed: {
        ...mapGetters('traceabilityContractModule', {
            cultivations: 'getCultivationTypes'
        }),
        currentComponent() {
            this.$emit('input', []);
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        },
        safrasFiltered() {
            return this.safras.filter(safra => safra.tipoSafra === 'SAFRA');
        },
        cultivationsFiltered() {
            return this.cultivations.filter(cultivation => cultivation.codigo === 'SOJA');
        }
    },
    watch: {
        'data.producerId'(newVal) {
            if (!newVal) {
                this.data.propertyId = null;
                this.properties = [];
            }
        }
    },
    methods: {
        ...mapActions('traceabilityContractModule', [
            'fetchCultivations'
        ]),
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        async fetchSafras() {
            const { data } = await UtilsService.getSafrasVigentesSise();
            this.safras = data;
        },

        setDefaultCultivationAndCrop() {
            this.$nextTick(() => {
                if (this.cultivationsFiltered && this.cultivationsFiltered.length > 0) {
                    this.data.cultivationId = this.cultivationsFiltered[0].id;
                }

                if (this.safrasFiltered && this.safrasFiltered.length > 0) {
                    this.data.cropId = this.safrasFiltered[0].id;
                }
            });
        },
        resetData () {
            this.data = {
                ...this.data,
                producerId: null,
                propertyId: null,
                invoiceNumber: null,
                volume: null,
                invoiceDate: null,
                warehouseId: null,
                romaneo: null,
                truckLicensePlate: null
            };
            this.producers = [];
            this.properties = [];
            this.selectedFile = null;
            this.searchingProducers = false;
            this.searchingProperties = false;
            this.isRequesting = false;
            if (this.$refs.upload) {
                this.$refs.upload.clearFiles();
            }
        },
        close() {
            this.$emit('close');
        },
        async getProducers(searchText) {
            this.producersSearchText = searchText;
            if (!searchText || searchText.length < 3) {
                this.producers = [];
                return;
            }
            this.searchingProducers = true;
            const { data } = await RepresentanteService.findAllByFiltro({
                page: 0,
                size: 5,
                order: '',
                searchText
            });

            this.producers = sortBy(
                data.resultados.map(
                    ({ id, cpfCnpj: documento, nomeRazaoSocial: nome }) => ({
                        id,
                        documento:
                            formatters.numeralStringFormatToDocumento(
                                documento
                            ),
                        nome
                    })
                ),
                ['nome']
            );
            this.searchingProducers = false;
        },
        async getProperties(searchText) {
            this.propertiesSearchText = searchText;
            if (!searchText || searchText.length < 3) {
                this.properties = [];
                return;
            }
            this.searchingProperties = true;
            const { data } = await TerritorioService.listarVinculadoATerritorioVegaPorEmpresas({
                page: 0,
                size: 5,
                producerId: this.data.producerId,
                nameFilter: searchText
            });
            this.properties = data.content;
            this.searchingProperties = false;
        },
        goToWareHouseRegistration() {
            this.$router.push({
                name: 'CadastrarArmazem',
                params: { action: WarehouseListActionsEnum.UPLOAD_WAREHOUSES }
            });
        },
        async fetchWarehouses() {
            await ArmazemModuleService.getAllWarehouses([]).then(({ data }) => {
                this.warehouses = data;
            });
        },
        async addNewInvoice() {
            this.isRequesting = true;
            try {
                const { status } = await NotaFiscalService.addInvoice(this.selectedFile, this.data);
                if (status === 200) {
                    this.$notify.success({
                        message: this.$t('mensagens.sistema.inserindoNotaSucesso')
                    });
                    this.close();
                    this.$emit('refreshStockPage');
                }
            } catch (error) {
                let message = this.$t('mensagens.sistema.erroAoInserirNota');

                const errData = error && error.response && error.response.data;
                if (errData) {
                    const payload = typeof errData === 'string' ? errData : (errData.code || errData.message || JSON.stringify(errData));

                    const errorMap = {
                        PRODUCER_NOT_FOUND: 'add_modal.exceptions.producer_not_found',
                        TERRITORY_NOT_FOUND: 'add_modal.exceptions.territory_not_found',
                        WAREHOUSE_NOT_FOUND: 'add_modal.exceptions.warehouse_not_found',
                        CULTIVATION_NOT_FOUND: 'add_modal.exceptions.cultivation_not_found',
                        CROP_NOT_FOUND: 'add_modal.exceptions.crop_not_found',
                        TERRITORY_VEGA_NOT_FOUND: 'add_modal.exceptions.territory_vega_not_found',
                        TERRITORY_BALANCE_NOT_FOUND: 'add_modal.exceptions.territory_balance_not_found',
                        TERRITORY_BALANCE_INSUFFICIENT: 'add_modal.exceptions.territory_balance_insufficient',
                        ERROR_INSERTING_INVOICE: 'add_modal.exceptions.error_inserting_invoice',
                        INVOICE_ALREADY_EXISTS: 'add_modal.exceptions.invoice_already_exists',
                        TERRITORY_VEGA_NOT_ELIGIBLE: 'add_modal.exceptions.territory_not_eligible',
                        ROMANEO_NUMBER_NOT_FOUND: 'add_modal.exceptions.romaneo_number_not_found',
                        ROMANEO_NUMBER_ALREADY_EXISTS: 'add_modal.exceptions.romaneo_number_already_exists'
                    };

                    const matchedKey = Object.keys(errorMap).find(key => payload.includes(key));
                    if (matchedKey) {
                        message = this.translate(errorMap[matchedKey]);
                    }
                }

                this.$notify.error({
                    message: message
                });
            }
            this.isRequesting = false;

        },
        handleFileChange(file, fileList) {
            this.selectedFile = file.raw;
        },
        handleFileRemove(file, fileList) {
            this.selectedFile = null;
        }
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3b3b3b;
    font-weight: 500;
    font-size: 16px;
}

.invoice-modal-upload-button {
    display: flex;
    justify-content: flex-start;
}

.invoice-modal-row{
    display: flex;
    justify-content: space-between;
    .invoice-modal-item:first-child {
        margin-right: 10px;
    }
    .invoice-modal-item:last-child {
        margin-left: 10px;
    }
}

.invoice-modal-item {
  flex: 1;
    .el-select, .el-input {
        width: 100%;
    }

}

.invoice-modal-buttons {
    justify-content: flex-end;
    margin-top: 20px;
    button:first-child {
        margin-right: 10px;
    }
    button:last-child {
        margin-left: 10px;
    }

}

.invoice-modal-mandatory span {
    color: var(--danger);
}

.not_found_option {
    height: 50px;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    .not_found_message{
        display: flex;
        justify-content: space-around;
        span {
            a {
                color: #036be4;
                cursor: pointer;
            }
        }
    }
}

// label {
//     font-weight: bold;
//     color: var(--primary);
//     padding: 0;
// }
</style>
